import { UnstyledButton } from '@mantine/core';
import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { iconButtonStyles } from './WorkspaceIconButton.styles';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
	/** Accessible name; icon buttons have no visible label. */
	label: string;
	size?: number;
	variant?: 'soft' | 'plain';
	/** `muted`: the design's `.icon-btn`, in the secondary ink until hovered. */
	tone?: 'ink' | 'muted';
	active?: boolean;
}

export const WorkspaceIconButton = forwardRef<HTMLButtonElement, Props>(
	(
		{
			label,
			size = 32,
			variant = 'plain',
			tone = 'ink',
			active = false,
			type = 'button',
			...rest
		},
		ref
	) => (
		<UnstyledButton
			ref={ref}
			type={type}
			aria-label={label}
			title={label}
			data-active={active}
			w={size}
			h={size}
			display="inline-flex"
			styles={{ root: iconButtonStyles({ variant, tone }) }}
			{...rest}
		/>
	)
);
WorkspaceIconButton.displayName = 'WorkspaceIconButton';
